import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PricingPage from "./pages/pricing";
import Resources from "./pages/resources";
import SolutionsHub from "./pages/solutions-hub";
import FreeTrialPage from "./pages/free-trial";
import ProductDemo from "./pages/product-demo";
import Homepage from "./pages/homepage";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import Home from "./pages/Home";
import Create from "./pages/Home/create";
import Templates from "./pages/Home/templates";
import Assemblies from "./pages/Home/assemblies";
import ProjectView from "pages/file-viewer/ProjectView";
import ProtectedRoute from "./components/ProtectedRoute";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<FreeTrialPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/solutions-hub" element={<SolutionsHub />} />
          <Route path="/free-trial" element={<FreeTrialPage />} />
          <Route path="/product-demo" element={<ProductDemo />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="*" element={<NotFound />} />

          {/* Protected Routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <Create />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assemblies"
            element={
              <ProtectedRoute>
                <Assemblies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:projectId"
            element={
              <ProtectedRoute>
                <ProjectView />
              </ProtectedRoute>
            }
          />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
